import React, { Component } from "react";
import i18n from "i18next";

export default class AudioPlayerProvider extends Component {
  constructor(props) {
    super(props);

    this.audio = new Audio();
    this.audio.loop = false;
    this.interval = null;

    let totalDuration = 0;
    if (props.soundList?.length > 0) {
      totalDuration = Math.round(
        props.soundList.reduce((a, b) => (a.endTime > b.endTime ? a : b)).endTime
      );
      if (Math.round(props.soundList[0].startTime) === 0) {
        this.audio.src = props.soundList[0].file;
      }
    }

    this.state = {
      playing: false,
      currentDuration: 0,
      totalDuration,
    };

    this.playOrPause = this.playOrPause.bind(this);
  }

  componentWillUnmount() {
    this.audio.pause();
    if (this.interval) clearInterval(this.interval);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.soundList !== nextProps.soundList) {
      let totalDuration = 0;
      if (nextProps.soundList?.length > 0) {
        totalDuration = Math.round(
          nextProps.soundList.reduce((a, b) => (a.endTime > b.endTime ? a : b)).endTime
        );
        if (Math.round(nextProps.soundList[0].startTime) === 0) {
          this.audio.src = nextProps.soundList[0].file;
        } else {
          this.audio.src = "";
        }
      } else {
        this.audio.src = "";
      }
      this.setState({ currentDuration: 0, totalDuration }, () => this.playOrPause(false));
    }

    if (this.props.modalVisible && !nextProps.modalVisible) {
      this.setState({ currentDuration: 0 }, () => {
        this.audio.src = "";
        this.playOrPause(false);
      });
    }
  }

  playOrPause(playing) {
    if (this.state.totalDuration === 0 && this.state.playing) {
      this.setState({ playing: false }, () => {
        this.audio.pause();
        if (this.interval) clearInterval(this.interval);
      });
      return;
    }
    if (this.state.totalDuration > 0) {
      this.setState({ playing }, () => {
        if (this.state.playing) {
          this.audio.play();
          this.interval = setInterval(() => {
            this.setState(
              (s) => {
                const next = s.currentDuration + 1;
                if (next >= s.totalDuration) {
                  clearInterval(this.interval);
                  this.audio.pause();
                  return { currentDuration: 0, playing: false };
                }
                return { currentDuration: next };
              },
              () => {
                const t = this.state.currentDuration;
                const { soundList } = this.props;
                const findSeg = (time) =>
                  soundList?.find(
                    (r) => Math.round(r.startTime) <= time && time <= Math.round(r.endTime)
                  );
                if (findSeg(t) !== findSeg(t - 1)) {
                  this.setAudioSettings(t);
                }
              }
            );
          }, 1000);
        } else {
          this.audio.pause();
          if (this.interval) clearInterval(this.interval);
        }
      });
    }
  }

  setAudioSettings(t) {
    const sound = this.props.soundList?.find(
      (r) => Math.round(r.startTime) <= t && t <= Math.round(r.endTime)
    );
    if (sound) {
      this.audio.src = sound.file;
      this.audio.volume = sound.volumeLevel;
      this.audio.currentTime = t - Math.round(sound.startTime);
      if (this.state.playing) this.audio.play();
    } else {
      this.audio.src = "";
      this.audio.currentTime = 0;
    }
  }

  fmt(s) {
    const sec = Math.round(s);
    const m = Math.floor(sec / 60);
    const ss = sec % 60;
    return `${String(m).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
  }

  render() {
    const { show } = this.props;
    if (!show) return null;

    const { playing, currentDuration, totalDuration } = this.state;
    const progress = totalDuration > 0 ? (currentDuration / totalDuration) * 100 : 0;
    const remaining = Math.max(0, totalDuration - currentDuration);

    return (
      <div
        style={{
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
          padding: "12px 14px",
          marginTop: "8px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Play / Pause */}
          <button
            type="button"
            aria-label={playing ? i18n.t("Sound.Pause") : i18n.t("Sound.Play")}
            onClick={() => this.playOrPause(!playing)}
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              background: "#7c3aed",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              padding: 0,
            }}
          >
            <i className="material-icons" style={{ fontSize: "16px", color: "white" }}>
              {playing ? "pause" : "play_arrow"}
            </i>
          </button>

          {/* Current time */}
          <span
            style={{
              fontSize: "12px",
              color: "#374151",
              fontVariantNumeric: "tabular-nums",
              flexShrink: 0,
            }}
          >
            {this.fmt(currentDuration)}
          </span>

          {/* Progress bar — click to seek */}
          <div
            style={{
              flex: 1,
              position: "relative",
              height: "4px",
              background: "#e5e7eb",
              borderRadius: "2px",
              cursor: "pointer",
            }}
            onClick={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const ratio = (e.clientX - rect.left) / rect.width;
              const t = Math.round(ratio * totalDuration);
              this.setState({ currentDuration: t }, () => {
                this.setAudioSettings(t);
              });
            }}
          >
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                height: "100%",
                background: "#7c3aed",
                borderRadius: "2px",
                width: `${progress}%`,
                transition: "width 0.2s linear",
                pointerEvents: "none",
              }}
            />
          </div>

          {/* Remaining time */}
          <span
            style={{
              fontSize: "12px",
              color: "#6b7280",
              fontVariantNumeric: "tabular-nums",
              flexShrink: 0,
            }}
          >
            -{this.fmt(remaining)}
          </span>
        </div>
      </div>
    );
  }
}
